import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'toggleLabel', 'chevron']

  connect() {
    this.expanded = true
    this.syncCollapsedState()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.expanded = !this.expanded
    this.panelTarget.classList.toggle('hidden', !this.expanded)
    this.chevronTarget?.classList.toggle('rotate-180', !this.expanded)
    this.syncCollapsedState()

    if (this.hasToggleLabelTarget) {
      this.toggleLabelTarget.textContent = this.expanded
        ? this.toggleLabelTarget.dataset.hideLabel
        : this.toggleLabelTarget.dataset.showLabel
    }
  }

  syncCollapsedState() {
    this.element.classList.toggle('workflow-step-branch--collapsed', !this.expanded)
  }
}
